module.exports = __webpack_public_path__ + "static/media/pre_cast_works_fixing_and_anchors.4c5da04a.jpg";